// extracted by mini-css-extract-plugin
export default {"list":"list_list__WOHou","item":"list_item__gnax2"};